import Decimal from "decimal.js"

/**
 * 分母が０だったら０を返す除算（Decimal対応済）
 * @param numerator:number 分子
 * @param denominator:number 分母
 * @return number
 */
export const quotOrZero = (numerator: number, denominator: number) => {
  return denominator !== 0
    ? new Decimal(numerator ?? 0).div(denominator).toNumber()
    : 0
}

/**
 * decimalに対応した加算
 * @param num 数値
 * @return number
 */
export const decimalPlus = (num: (number | null | undefined)[]) => {
  let result =
    num.reduce((a, b) => new Decimal(a ?? 0).plus(b ?? 0).toNumber()) ?? 0

  return result
}

/**
 * ミリ秒に変換
 * numberをTimeSpanで登録する際に使用
 * @param num target
 * @returns ミリ秒変換したnumber
 */
export const numberToMillisecond = (num: number): number => {
  const ミリ秒 = new Decimal(3600000)
  const targetNumber = new Decimal(num ?? 0)

  // 対象のNumberをミリ秒化して返却
  return targetNumber.times(ミリ秒).toNumber()
}
